import Label from './Label';
import Illustration from './Illustration';
import Actions from './Actions';
import { PropsWithChildren } from 'react';

const NotFound = ({ children }: PropsWithChildren) => {
	return <div className="w-full h-full flex flex-col gap-4 justify-center items-center p-4">{children}</div>;
};

NotFound.Illustration = Illustration;
NotFound.Label = Label;
NotFound.Actions = Actions;

export default NotFound;
